import { useState, useEffect } from 'react';
import { post } from 'aws-amplify/api';
import { CompanyProfile } from '../../types';

interface UserManagerProps {
  companies: CompanyProfile[];
  onUserCreated: () => void;
}

export function UserManager({ companies, onUserCreated }: UserManagerProps) {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [canUpload, setCanUpload] = useState(false);
  const [role, setRole] = useState('User'); // New state for role
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (companies.length > 0 && !selectedCompanyId) {
      setSelectedCompanyId(companies[0].id);
    }
  }, [companies, selectedCompanyId]);

  const handleCreateUser = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('Creating user...');
    try {
      await post({
        apiName: 'aslanwebsftpapi',
        path: '/admin/users',
        options: {
          body: {
            email,
            firstName,
            lastName,
            phoneNumber,
            companyId: selectedCompanyId,
            canUpload,
            role,
          },
        },
      }).response;
      setMessage(
        `Successfully created ${role.toLowerCase()} ${email}. They will receive an email with a temporary password.`
      );
      setEmail('');
      setFirstName('');
      setLastName('');
      setPhoneNumber('');
      onUserCreated();
    } catch (error) {
      console.error('Error creating user:', error);
      setMessage('Failed to create user. Check console for details.');
    }
  };
  return (
    <div
      style={{ border: '1px solid #ccc', padding: '15px', marginTop: '20px' }}
    >
      <h3>Create New User</h3>
      <form
        onSubmit={handleCreateUser}
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
      >
        <div>
          <label>
            Email:{' '}
            <input
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
        </div>
        <div>
          <label>
            First Name:{' '}
            <input
              type='text'
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </label>
        </div>
        <div>
          <label>
            Last Name:{' '}
            <input
              type='text'
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
          </label>
        </div>
        <div>
          <label>
            Mobile Number (e.g., +44...):{' '}
            <input
              type='tel'
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
          </label>
        </div>
        <div>
          <label>
            Company:
            <select
              value={selectedCompanyId}
              onChange={(e) => setSelectedCompanyId(e.target.value)}
              required
            >
              <option value='' disabled>
                Select a company
              </option>
              {companies.map((c: CompanyProfile) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        {/* --- NEW ROLE SELECTOR --- */}
        <div>
          <label>
            Role:
            <select value={role} onChange={(e) => setRole(e.target.value)}>
              <option value='User'>User</option>
              <option value='Admin'>Admin</option>
            </select>
          </label>
        </div>
        {/* --- END OF CHANGE --- */}
        <div>
          <label>
            <input
              type='checkbox'
              checked={canUpload}
              onChange={(e) => setCanUpload(e.target.checked)}
            />{' '}
            Grant Upload Permission
          </label>
        </div>
        <button type='submit' disabled={!selectedCompanyId}>
          Create User
        </button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
}
